import React from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';

const ProductFocus = ({ focus }) => focus && (
    <div className="text-center"><CheckCircleOutlined /></div>
);

export default ProductFocus;
